<template>
    <div>
        <ValidationObserver ref="form">
            <b-row>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('leaving_academic_year')">
                        <academic-years-selectbox v-model="filter.leaving_academic_year"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('leaving_semester')">
                        <parameter-selectbox
                            code="semester"
                            v-model="filter.leaving_semester"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <processing-button @click="getReport" label="get_report" :processing="processing"/>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationObserver} from 'vee-validate'
import AcademicYearsSelectbox from '@/components/interactive-fields/AcademicYearsSelectbox'
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox'
import ProcessingButton from '@/components/elements/ProcessingButton'
import StudentReportService from '@/services/StudentReportService'
import qs from 'qs'

export default {
    components: {
        ValidationObserver,
        AcademicYearsSelectbox,
        ParameterSelectbox,
        ProcessingButton
    },
    data() {
        return {
            processing: false,
            filter: {
                leaving_academic_year: null,
                leaving_semester: null
            }
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.form.validate()
            if (!isValid) return

            this.processing = true
        
            const config = {
                params: {filter: {...this.filter}},
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }

            StudentReportService.leavingStudentReport(config)
                .then((response) => {
                    this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                })
                .catch((error) => {
                    this.showErrors(error)
                })
                .finally(() => {
                    this.processing = false
                })
        }
    }
}
</script>
